import React from 'react';
import { CustomClassContainerProps, CustomClassContainer } from '../../utility';

interface RadioInputProps<T extends string | number>
  extends CustomClassContainerProps {
  label: string;
  name: string;
  options: T[];
  children?: React.ReactNode | React.ReactNode[];
  value?: T;
  onChange: (value: T) => void;
}

function RadioInput<T extends string | number>({
  label,
  name,
  options,
  classes = [],
  value,
  onChange,
  children = [],
}: RadioInputProps<T>) {
  return (
    <CustomClassContainer classes={classes}>
      <div className='flex w-auto flex-col'>
        <div className='mb-2 flex flex-row items-center justify-between'>
          <label
            className='text-base font-medium tracking-tight text-gray-dark'
            htmlFor={name}
          >
            {label}
          </label>
          {children ? <div>{children}</div> : null}
        </div>
        <div className='flex flex-row items-center space-x-5'>
          {options.map((opt, idx) => (
            <label
              className='inline-flex cursor-pointer items-center'
              key={`radio-${idx}`}
            >
              <input
                type='radio'
                className='form-radio cursor-pointer border border-gray-light text-white checked:ring-1 checked:ring-green checked:ring-offset-0 focus:ring-1 focus:ring-green focus:ring-offset-0'
                checked={opt === value}
                name={name}
                value={opt}
                onChange={(e) => onChange(e.target.value as T)}
              />
              <span className='ml-2 select-none text-base font-medium text-gray-darkest'>
                {opt}
              </span>
            </label>
          ))}
        </div>
      </div>
    </CustomClassContainer>
  );
}

export default RadioInput;
